module.exports = __webpack_public_path__ + "img/5-3.b65d8301.jpg";